var UA = window.navigator.userAgent,
    ua = UA.toLowerCase()
/**
 * @desc 千分位格式化
 * @param {Number} val - 数字
 * @param {*} n - 取几位小数
 */
export function numberic(val, n) {
    var p = Number(val).toFixed(n || 2)
    var ary = p.split('.'),
        i = ary[0],
        f = ary[1]
    i = i
        .split('')
        .reverse()
        .join('')
        .match(new RegExp('([A-Za-z0-9]{1,3})+?', 'g'))
        .join(',')
        .split('')
        .reverse()
        .join('')

    return i + '.' + f
}

/**
 * @desc 校验车牌号
 * @param {String|Number} number - 车牌号
 * @return {Boolean}
 */
export function verifyCarNumber(number) {
    var re = /^[\u4e00-\u9fa5]{1}[A-Za-z]{1}[A-Za-z_0-9]{5,6}$/
    return re.test(String(number))
}

/**
 * @desc 校验邮箱格式
 * @param {String} email - 邮箱地址
 * @return {Boolean}
 */
export function verifyEmail(email) {
    var re = /^[A-Za-z0-9]+([._\\-]*[A-Za-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
    return email && typeof email === 'string' && re.test(email)
}

/**
 * @desc 校验身份证
 * @param {String|Number} code
 * @return {Boolean}
 */
function verifyIdCard(code) {
    var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 '
    }
    var tip = ''
    var pass = true
    if (typeof code == 'number') {
        code = String(code)
    }

    if (
        !code ||
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)
    ) {
        tip = '身份证号格式错误'
        pass = false
    } else if (!city[code.substr(0, 2)]) {
        tip = '地址编码错误'
        pass = false
    } else {
        //18位身份证需要验证最后一位校验位
        if (code.length == 18) {
            code = code.split('')
            //∑(ai×Wi)(mod 11)
            //加权因子
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
            //校验位
            var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
            var sum = 0
            var ai = 0
            var wi = 0
            for (var i = 0; i < 17; i++) {
                ai = code[i]
                wi = factor[i]
                sum += ai * wi
            }
            var last = parity[sum % 11]
            if (parity[sum % 11] != code[17]) {
                tip = '校验位错误'
                pass = false
            }
        }
    }
    if (!pass) console.log(tip)
    return pass
}

/**
 * @desc 通过身份证获取性别
 * @param {String} code
 * @return {String} male- 男, female - 女
 */
export function getSex(code) {
    var sexno, sex
    if (code.length == 18) {
        sexno = code.substring(16, 17)
    } else if (code.length == 15) {
        sexno = code.substring(14, 15)
    } else {
        return ''
    }
    var tempid = sexno % 2
    if (tempid == 0) {
        sex = 'female'
    } else {
        sex = 'male'
    }
    return sex
}

// Speed up calls to hasOwnProperty
var hasOwnProperty = Object.prototype.hasOwnProperty

export function isEmpty(obj) {
    // null and undefined are "empty"
    if (obj == null) return true

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false
    if (obj.length === 0) return true

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== 'object') return true

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false
    }

    return true
}

export var OS = {
    isIOS: /iphone|ipad|ipod|ios/.test(ua),
    isAndroid: ua.indexOf('android') > 0,
    isWechat: ua.indexOf('micromessenger') > 0,
    isWandaApp: ua.indexOf('com.wandaloans.timesloan') > 0,
    isSafari: false,
    isChrome: false,
    isBaidu: false,
    isLiebao: false,
    is360: false,
    isSougo: false,
    isUc: false,
    is2345: false,
    isQQ: false
}

if (ua.indexOf('ubrowser') > -1 || UA.indexOf('UC') > -1) {
    OS.isUc = true
} else if (ua.indexOf('mqqbrowser') > -1) {
    OS.isQQ = true
} else if (UA.indexOf('Baidu') > -1 || UA.indexOf('BIDUBrowser') > -1) {
    OS.isBaidu = true
} else if (ua.indexOf('liebaofast') > -1) {
    OS.isLiebao = true
} else if (UA.indexOf('360EE') > -1 || UA.indexOf('360SE') > -1) {
    OS.is360 = true
} else if (UA.indexOf('MetaSr') > -1 || UA.indexOf('Sogou') > -1) {
    OS.isSougo = true
} else if (UA.indexOf('2345Explorer') > -1) {
    OS.is2345 = true
} else if (UA.indexOf('Chrome') > -1 || UA.indexOf('CriOS') > -1) {
    OS.isChrome = true
} else if (ua.indexOf('safari') > -1) {
    OS.isSafari = true
}

OS.version = _getOSVersion()
OS.appVersion = _getWandadaiVersion()

function _getOSVersion() {
    if (OS.isIOS) {
        return ua.match(/OS\s+(\d)_\d+\s+like Mac OS X/)
    }
    if (OS.isAndroid) {
        ua.substr(ua.indexOf('Android') + 8, 3)
    }
}

function _getWandadaiVersion() {
    var v = ua.split(';')[1] || ''
    return (v.match(/\d+\.\d+\.\d+\((\d+)\)/) || [])[1] || ''
}

export function getServerUrl() {
    // 测试地址 https://kf.uat.wandaph.com/webchat/web/h5?groupNo=wdd_web&tenantId=wanda&callee=wdd_h5
    // 生产地址 https://kf.wandaph.com/webchat/web/h5?groupNo=wdd_web&tenantId=wandaph&callee=wdd_h5
    var url =
        'https://kf.uat.wandaph.com/webchat/web/h5?groupNo=wdd_web&tenantId=wanda&callee=wdd_h5'
    location.href = url
}

export function goWxAppUrl(channel) {
    // 万达普惠APP存量引流：weixin://dl/business/?t=6Wc5cz6mqZa（永久链接）
    // 万达普惠APP存量引流：weixin://dl/business/?t=YuaX6PKh0el（永久链接）
    // 快易花APP存量引流：weixin://dl/business/?t=KtxiwVxouxu（永久链接）
    // 短信获新：weixin://dl/business/?t=hDZ3Vt40t7t（永久链接）
    //wdd万达贷，kyh快易花，wdph 万达普惠
    console.log(channel)
    if (channel === 'wdd') {
        location.href = 'weixin://dl/business/?t=6Wc5cz6mqZa'
    } else if (channel === 'kyh') {
        location.href = 'weixin://dl/business/?t=KtxiwVxouxu'
    } else if (channel === 'wdph') {
        location.href = 'weixin://dl/business/?t=YuaX6PKh0el'
    } else {
        location.href = 'weixin://dl/business/?t=hDZ3Vt40t7t'
    }
}



// WEBPACK FOOTER //
// ./src/utils/tools.js